import { render, staticRenderFns } from "./CustomerTableLayout.vue?vue&type=template&id=465123d6&scoped=true&lang=pug&"
import script from "./CustomerTableLayout.vue?vue&type=script&lang=js&"
export * from "./CustomerTableLayout.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTableLayout.vue?vue&type=style&index=0&id=465123d6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465123d6",
  null
  
)

export default component.exports